import toast from "react-hot-toast"

export function triggerSuccessToast(message: string) {
  toast.dismiss()
  toast.success(message, {duration: 5000, position: "bottom-center"})
}
